import { useState, MouseEvent, Dispatch, SetStateAction } from "react";
import { Button, Menu, MenuItem } from "@mui/material";
import { Sort } from "@mui/icons-material";
import { FilterSortGroup } from "../projectTypes";

interface ProjectDetailsDashWidgetSortProps {
  filterSortGroup: FilterSortGroup;
  setFilterSortGroup: Dispatch<SetStateAction<FilterSortGroup>>;
}

const sortOptions: { id: string; label: string }[] = [
  { id: "status", label: "Status" },
  { id: "start-date", label: "Start Date" },
  { id: "end-date", label: "End Date" },
  { id: "name-asc", label: "Name (A-Z)" },
  { id: "name-desc", label: "Name (Z-A)" },
  { id: "created", label: "Created On" },
];

export default function ProjectDetailsDashWidgetSort({
  filterSortGroup,
  setFilterSortGroup,
}: ProjectDetailsDashWidgetSortProps) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const currentSort = filterSortGroup?.sort ?? null;

  const handleOpen = (e: MouseEvent<HTMLButtonElement>) =>
    setAnchorEl(e.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const handleSelect = (option: { id: string; label: string }) => {
    setFilterSortGroup((prev: FilterSortGroup) => {
      const isSame = prev?.sort?.id === option.id;
      if (isSame) {
        const { sort, ...rest } = prev || {};
        return { ...rest, sort: null } as FilterSortGroup;
      }
      return {
        ...prev,
        sort: { id: option.id, label: option.label },
      };
    });
    handleClose();
  };

  return (
    <>
      <Button
        color="inherit"
        variant="text"
        startIcon={<Sort />}
        onClick={handleOpen}
        sx={{ color: open ? "primary.main" : "text.secondary" }}
      >
        {currentSort?.id
          ? `SORT TASKS: ${currentSort.label.toUpperCase()}`
          : "SORT"}
      </Button>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        {sortOptions.map((opt) => (
          <MenuItem
            key={opt.id}
            selected={currentSort?.id === opt.id}
            onClick={() => handleSelect(opt)}
          >
            {opt.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
